import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import { useState, useEffect } from "react";
import LRQA from "./../Images/LRQA.png";

const Footer = () => {
  return (
    <div className="container-fluid oh">
      {/* <div className="blueDividerBar"></div> */}
      <section id="section1">
        <div className="container container_medium">
          <div className="row">
            <div className="col-6 d-block d-lg-none">
              <a
                className="d-inline-flex align-items-center mb-2 link-dark text-decoration-none velo-log"
                href="/"
                aria-label="Velosure Icon"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="163.729"
                  height="38.482"
                  viewBox="0 0 163.729 38.482"
                >
                  <g
                    id="Group_1590"
                    data-name="Group 1590"
                    transform="translate(-687.36 -80.891)"
                  >
                    <g
                      id="Group_1563"
                      data-name="Group 1563"
                      transform="translate(687.36 80.891)"
                    >
                      <path
                        id="Path_1898"
                        data-name="Path 1898"
                        d="M454.489,479.122a3.076,3.076,0,0,1,0-5.961.566.566,0,0,0,.434-.609.535.535,0,0,0-.013-.131,23.406,23.406,0,0,0-.7-2.7.641.641,0,0,0-.737-.386,3.045,3.045,0,0,1-3.508-1.438,3.015,3.015,0,0,1,.491-3.715.553.553,0,0,0,.187-.449.616.616,0,0,0-.152-.432,20.755,20.755,0,0,0-1.965-1.965.594.594,0,0,0-.807.035,3.1,3.1,0,0,1-5.329-2.211,3.008,3.008,0,0,1,.1-.733.564.564,0,0,0,0-.377.578.578,0,0,0-.382-.4,18.815,18.815,0,0,0-2.666-.737.6.6,0,0,0-.7.421,3.118,3.118,0,0,1-6.035.035.6.6,0,0,0-.7-.456,17.632,17.632,0,0,0-2.666.737.564.564,0,0,0-.4.648.79.79,0,0,0,.017.128,3.146,3.146,0,0,1,.1.743,3.1,3.1,0,0,1-5.33,2.2.593.593,0,0,0-.807-.035,17.275,17.275,0,0,0-1.965,1.965.617.617,0,0,0-.153.432.554.554,0,0,0,.187.449,3.013,3.013,0,0,1,.491,3.715,3.063,3.063,0,0,1-3.508,1.438.641.641,0,0,0-.737.386,17.982,17.982,0,0,0-.7,2.7.636.636,0,0,0-.015.151.565.565,0,0,0,.436.589,3.076,3.076,0,0,1,0,5.961.566.566,0,0,0-.434.609.583.583,0,0,0,.013.131,23.448,23.448,0,0,0,.7,2.7.64.64,0,0,0,.737.386,3.046,3.046,0,0,1,3.508,1.438,3.014,3.014,0,0,1-.491,3.715.552.552,0,0,0-.187.449.619.619,0,0,0,.153.432,20.765,20.765,0,0,0,1.965,1.964.593.593,0,0,0,.807-.035,3.1,3.1,0,0,1,5.33,2.211,2.988,2.988,0,0,1-.1.733.567.567,0,0,0,0,.377.58.58,0,0,0,.382.4,18.9,18.9,0,0,0,2.666.737.6.6,0,0,0,.7-.421,3.118,3.118,0,0,1,6.035-.035.6.6,0,0,0,.7.456,17.664,17.664,0,0,0,2.666-.737.564.564,0,0,0,.4-.648.7.7,0,0,0-.017-.128,3.122,3.122,0,0,1-.1-.743,3.1,3.1,0,0,1,5.329-2.2.594.594,0,0,0,.807.035,17.335,17.335,0,0,0,1.965-1.964.618.618,0,0,0,.152-.432.551.551,0,0,0-.187-.449,3.015,3.015,0,0,1-.491-3.715,3.063,3.063,0,0,1,3.508-1.438.641.641,0,0,0,.737-.386,17.94,17.94,0,0,0,.7-2.7.611.611,0,0,0,.015-.151A.565.565,0,0,0,454.489,479.122Zm-7.982-11.067q.219.291.423.593a.4.4,0,0,1-.237.609l-10.225,2.462a2.282,2.282,0,0,0-1.591,1.388l-1.083,2.771a.2.2,0,0,1-.37,0l-.384-.986a.992.992,0,0,1,.006-.735l.927-2.262a2.281,2.281,0,0,1,1.559-1.349l10.561-2.633A.4.4,0,0,1,446.507,468.055Zm-11.441,11.278,1.923-4.694a2.281,2.281,0,0,1,1.536-1.343l9.243-2.409a.4.4,0,0,1,.467.232q.157.392.29.8a.393.393,0,0,1-.281.514l-8.7,2.141a2.283,2.283,0,0,0-1.58,1.385l-2.072,5.3a.2.2,0,0,1-.37,0l-.463-1.185A.991.991,0,0,1,435.066,479.333Zm.654-16.676a13.422,13.422,0,0,1,8.743,3.223.4.4,0,0,1-.17.686l-10.658,2.524a2.282,2.282,0,0,0-1.6,1.389l-.171.439a.2.2,0,0,1-.37,0l-2.286-5.874a.71.71,0,0,1,.334-.888A13.414,13.414,0,0,1,435.72,462.657Zm-.207,26.968A13.482,13.482,0,0,1,424.825,468.2a.7.7,0,0,1,1.207.141l7.174,17.391a1.389,1.389,0,0,0,1.284.859h2.489a1.389,1.389,0,0,0,1.285-.863l3-7.329a2.281,2.281,0,0,1,1.548-1.346l5.893-1.5a.4.4,0,0,1,.5.379c0,.071,0,.143,0,.214A13.485,13.485,0,0,1,435.512,489.625Z"
                        transform="translate(-416.514 -456.901)"
                        fill="#00a8ff"
                      />
                      <g
                        id="Group_1560"
                        data-name="Group 1560"
                        transform="translate(41.242 3.703)"
                      >
                        <g
                          id="Group_1558"
                          data-name="Group 1558"
                          transform="translate(0 0)"
                        >
                          <path
                            id="Path_1899"
                            data-name="Path 1899"
                            d="M509.12,465.216h4.462L520,481.7l6.446-16.488h4.432l-8.708,21.261h-4.278Z"
                            transform="translate(-509.12 -465.216)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1900"
                            data-name="Path 1900"
                            d="M552.961,485.367c0-4.9,3.348-8.182,8.4-8.182s8.4,3.285,8.4,8.182v.713l-.311.31H556.742a4.528,4.528,0,0,0,4.619,4.06,4.7,4.7,0,0,0,4.246-2.6h3.782a8.2,8.2,0,0,1-8.027,5.7C556.309,493.549,552.961,490.264,552.961,485.367Zm12.769-2.076a4.68,4.68,0,0,0-8.74,0Z"
                            transform="translate(-533.436 -471.855)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1901"
                            data-name="Path 1901"
                            d="M595.691,465.216h3.719v21.261h-3.719Z"
                            transform="translate(-557.136 -465.216)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1902"
                            data-name="Path 1902"
                            d="M609.053,485.367c0-4.9,3.348-8.182,8.4-8.182s8.4,3.285,8.4,8.182-3.348,8.182-8.4,8.182S609.053,490.264,609.053,485.367Zm13.079,0c0-2.944-1.86-4.9-4.68-4.9s-4.68,1.953-4.68,4.9,1.86,4.9,4.68,4.9S622.132,488.312,622.132,485.367Z"
                            transform="translate(-564.548 -471.855)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1903"
                            data-name="Path 1903"
                            d="M649,487.847h3.5c.124,1.549,1.612,2.6,3.689,2.6s3.47-.806,3.47-2.014c0-.744-.93-1.271-3.811-1.829-4.495-1.022-5.92-2.045-5.92-4.618,0-2.882,2.51-4.8,6.261-4.8a6.738,6.738,0,0,1,6.477,4.029l-3.409.836a3.317,3.317,0,0,0-3.068-1.766c-1.519,0-2.542.62-2.542,1.519,0,.651.713,1.054,2.913,1.55,5.175,1.084,6.818,2.262,6.818,5.083,0,3.068-2.883,5.114-7.189,5.114C652.008,493.549,649.125,491.256,649,487.847Z"
                            transform="translate(-586.705 -471.855)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1904"
                            data-name="Path 1904"
                            d="M700.609,493.655H696.89v-1.147a6.49,6.49,0,0,1-4.215,1.581c-4.247,0-7.067-2.51-7.067-6.291v-9.64h3.719v9.205c0,2.077,1.519,3.44,3.782,3.44s3.781-1.364,3.781-3.44v-9.205h3.719Z"
                            transform="translate(-607.009 -472.394)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1905"
                            data-name="Path 1905"
                            d="M725.693,477.773h3.719V479.6a4.667,4.667,0,0,1,3.75-2.139,4.559,4.559,0,0,1,1.642.31v2.852h-1.271c-2.479,0-4.122,1.395-4.122,3.471v9.174h-3.719Z"
                            transform="translate(-629.242 -472.009)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1906"
                            data-name="Path 1906"
                            d="M746.435,485.367c0-4.9,3.348-8.182,8.4-8.182s8.4,3.285,8.4,8.182v.713l-.31.31H750.215a4.528,4.528,0,0,0,4.619,4.06,4.7,4.7,0,0,0,4.246-2.6h3.782a8.2,8.2,0,0,1-8.028,5.7C749.783,493.549,746.435,490.264,746.435,485.367Zm12.768-2.076a4.679,4.679,0,0,0-8.74,0Z"
                            transform="translate(-640.747 -471.855)"
                            fill="#fff"
                          />
                        </g>
                        <g
                          id="Group_1559"
                          data-name="Group 1559"
                          transform="translate(8.482 24.89)"
                        >
                          <path
                            id="Path_1907"
                            data-name="Path 1907"
                            d="M528.165,524.059a2.527,2.527,0,0,1,2.6-2.568,2.584,2.584,0,0,1,2.165,1.115l-.568.352a1.935,1.935,0,1,0,0,2.2l.568.353a2.585,2.585,0,0,1-2.165,1.115A2.527,2.527,0,0,1,528.165,524.059Z"
                            transform="translate(-528.165 -521.319)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1908"
                            data-name="Path 1908"
                            d="M543.541,524.592l-1.978,4.445a1.036,1.036,0,0,1-.942.676,1.263,1.263,0,0,1-.841-.352l.259-.475a.671.671,0,0,0,.489.23.5.5,0,0,0,.467-.331l.266-.547-1.6-3.647h.712l1.237,2.927,1.237-2.927Z"
                            transform="translate(-534.543 -523.039)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1909"
                            data-name="Path 1909"
                            d="M548.773,526.319a1.967,1.967,0,0,1,3.632-1l-.539.324a1.323,1.323,0,1,0,0,1.352l.539.323a1.967,1.967,0,0,1-3.632-1Z"
                            transform="translate(-539.595 -522.932)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1910"
                            data-name="Path 1910"
                            d="M558.608,521.2h.619v5.179h-.619Z"
                            transform="translate(-545.05 -521.158)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1911"
                            data-name="Path 1911"
                            d="M565.632,526.593h-3.158a1.319,1.319,0,0,0,1.36,1.079,1.519,1.519,0,0,0,1.237-.6l.425.367a2.068,2.068,0,0,1-1.683.8,1.926,1.926,0,0,1-2.007-1.935,1.92,1.92,0,0,1,3.84.015C565.646,526.406,565.639,526.506,565.632,526.593Zm-3.165-.561h2.525a1.281,1.281,0,0,0-2.525,0Z"
                            transform="translate(-546.824 -522.932)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1912"
                            data-name="Path 1912"
                            d="M575.952,521.514a.414.414,0,1,1,.417.41A.407.407,0,0,1,575.952,521.514Zm.108,1.143h.619v3.668h-.619Z"
                            transform="translate(-554.67 -521.104)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1913"
                            data-name="Path 1913"
                            d="M583.356,525.888v2.265h-.619v-2.071A1.012,1.012,0,0,0,581.666,525a1.048,1.048,0,0,0-1.122,1.1v2.057h-.619v-3.668h.619v.561a1.537,1.537,0,0,1,1.324-.647A1.4,1.4,0,0,1,583.356,525.888Z"
                            transform="translate(-556.874 -522.932)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1914"
                            data-name="Path 1914"
                            d="M589.211,527.664l.346-.446a1.552,1.552,0,0,0,1.136.46c.482,0,.849-.187.849-.518,0-.352-.41-.46-.892-.575-.6-.151-1.316-.338-1.316-1.108,0-.712.648-1.079,1.4-1.079a1.972,1.972,0,0,1,1.345.5l-.345.453a1.416,1.416,0,0,0-.993-.4c-.424,0-.777.166-.777.482,0,.359.417.46.906.575.6.144,1.309.324,1.309,1.086,0,.726-.655,1.136-1.481,1.136A2.119,2.119,0,0,1,589.211,527.664Z"
                            transform="translate(-562.024 -522.932)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1915"
                            data-name="Path 1915"
                            d="M597.495,526.808v-2.216h.619v2.129a1.043,1.043,0,0,0,2.086,0v-2.129h.619v2.216a1.666,1.666,0,0,1-3.323,0Z"
                            transform="translate(-566.619 -523.039)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1916"
                            data-name="Path 1916"
                            d="M609.177,524.463v.64h-.122a1.164,1.164,0,0,0-1.251,1.251v1.834h-.619V524.52h.619v.633a1.416,1.416,0,0,1,1.251-.691Z"
                            transform="translate(-571.993 -522.967)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1917"
                            data-name="Path 1917"
                            d="M616.166,524.485v3.668h-.619v-.662a1.675,1.675,0,0,1-1.424.748,1.922,1.922,0,0,1,0-3.841,1.676,1.676,0,0,1,1.424.748v-.662Zm-.619,1.834a1.312,1.312,0,1,0-1.309,1.323A1.286,1.286,0,0,0,615.547,526.319Z"
                            transform="translate(-574.824 -522.932)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1918"
                            data-name="Path 1918"
                            d="M626.782,525.888v2.265h-.619v-2.071A1.012,1.012,0,0,0,625.092,525a1.048,1.048,0,0,0-1.122,1.1v2.057h-.619v-3.668h.619v.561a1.537,1.537,0,0,1,1.324-.647A1.4,1.4,0,0,1,626.782,525.888Z"
                            transform="translate(-580.96 -522.932)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1919"
                            data-name="Path 1919"
                            d="M632.767,526.319a1.967,1.967,0,0,1,3.632-1l-.539.324a1.323,1.323,0,1,0,0,1.352l.539.323a1.967,1.967,0,0,1-3.632-1Z"
                            transform="translate(-586.182 -522.932)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1920"
                            data-name="Path 1920"
                            d="M645.815,526.593h-3.158a1.319,1.319,0,0,0,1.36,1.079,1.519,1.519,0,0,0,1.237-.6l.424.367a2.068,2.068,0,0,1-1.683.8,1.926,1.926,0,0,1-2.007-1.935,1.92,1.92,0,0,1,3.841.015C645.83,526.406,645.823,526.506,645.815,526.593Zm-3.165-.561h2.524a1.28,1.28,0,0,0-2.524,0Z"
                            transform="translate(-591.297 -522.932)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1921"
                            data-name="Path 1921"
                            d="M659.754,524.485v3.668h-.619v-.662a1.675,1.675,0,0,1-1.424.748,1.922,1.922,0,0,1,0-3.841,1.676,1.676,0,0,1,1.424.748v-.662Zm-.619,1.834a1.312,1.312,0,1,0-1.309,1.323A1.286,1.286,0,0,0,659.135,526.319Z"
                            transform="translate(-599 -522.932)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1922"
                            data-name="Path 1922"
                            d="M667.623,523.926v2.028c0,.4.216.568.59.568a1.054,1.054,0,0,0,.51-.137v.583a1.276,1.276,0,0,1-.64.151A.964.964,0,0,1,667,526.055v-2.129h-.661v-.561H667v-.985h.619v.985h1.1v.561Z"
                            transform="translate(-604.805 -521.812)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1923"
                            data-name="Path 1923"
                            d="M678.136,523.926v2.028c0,.4.216.568.59.568a1.054,1.054,0,0,0,.51-.137v.583a1.276,1.276,0,0,1-.64.151.964.964,0,0,1-1.079-1.064v-2.129h-.661v-.561h.661v-.985h.619v.985h1.1v.561Z"
                            transform="translate(-610.636 -521.812)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1924"
                            data-name="Path 1924"
                            d="M687.408,524.114v2.265h-.619v-2.071a1.012,1.012,0,0,0-1.071-1.086,1.048,1.048,0,0,0-1.122,1.1v2.057h-.619V521.2h.619v2.093a1.519,1.519,0,0,1,1.324-.669A1.4,1.4,0,0,1,687.408,524.114Z"
                            transform="translate(-614.586 -521.158)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1925"
                            data-name="Path 1925"
                            d="M697.219,526.593h-3.158a1.319,1.319,0,0,0,1.36,1.079,1.52,1.52,0,0,0,1.237-.6l.424.367a2.069,2.069,0,0,1-1.683.8,1.926,1.926,0,0,1-2.007-1.935,1.92,1.92,0,0,1,3.841.015C697.234,526.406,697.227,526.506,697.219,526.593Zm-3.165-.561h2.525a1.281,1.281,0,0,0-2.525,0Z"
                            transform="translate(-619.809 -522.932)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1926"
                            data-name="Path 1926"
                            d="M709.774,524.463v.64h-.122a1.163,1.163,0,0,0-1.251,1.251v1.834h-.619V524.52h.619v.633a1.415,1.415,0,0,1,1.251-.691Z"
                            transform="translate(-627.789 -522.967)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1927"
                            data-name="Path 1927"
                            d="M713.515,521.514a.413.413,0,1,1,.417.41A.407.407,0,0,1,713.515,521.514Zm.108,1.143h.619v3.668h-.619Z"
                            transform="translate(-630.969 -521.104)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1928"
                            data-name="Path 1928"
                            d="M720.77,528.739l-.64.165c-.014-.331-.3-.546-.719-.546h-1.352a.9.9,0,0,1-1.022-.871.945.945,0,0,1,.453-.827,1.576,1.576,0,0,1-.5-1.165,1.6,1.6,0,0,1,1.676-1.589,1.762,1.762,0,0,1,.9.237.782.782,0,0,1,.834-.633h.281v.575h-.245a.412.412,0,0,0-.453.4,1.541,1.541,0,0,1,.359,1.007,1.608,1.608,0,0,1-1.676,1.6,1.713,1.713,0,0,1-.777-.173.5.5,0,0,0-.23.41c0,.259.209.424.518.424h1.345A1.14,1.14,0,0,1,720.77,528.739Zm-3.143-3.244a1.036,1.036,0,1,0,1.035-1A1,1,0,0,0,717.627,525.5Z"
                            transform="translate(-632.895 -522.439)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1929"
                            data-name="Path 1929"
                            d="M729.995,524.114v2.265h-.619v-2.071a1.012,1.012,0,0,0-1.072-1.086,1.048,1.048,0,0,0-1.122,1.1v2.057h-.619V521.2h.619v2.093a1.518,1.518,0,0,1,1.323-.669A1.4,1.4,0,0,1,729.995,524.114Z"
                            transform="translate(-638.207 -521.158)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1930"
                            data-name="Path 1930"
                            d="M736.743,523.926v2.028c0,.4.216.568.59.568a1.054,1.054,0,0,0,.51-.137v.583a1.276,1.276,0,0,1-.64.151.964.964,0,0,1-1.079-1.064v-2.129h-.662v-.561h.662v-.985h.619v.985h1.1v.561Z"
                            transform="translate(-643.143 -521.812)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1931"
                            data-name="Path 1931"
                            d="M750.457,526.319a1.842,1.842,0,0,1-1.841,1.92,1.676,1.676,0,0,1-1.424-.748v2.029h-.619v-5.035h.619v.662a1.677,1.677,0,0,1,1.424-.748A1.841,1.841,0,0,1,750.457,526.319Zm-.64,0a1.313,1.313,0,1,0-1.316,1.323A1.288,1.288,0,0,0,749.817,526.319Z"
                            transform="translate(-649.305 -522.932)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1932"
                            data-name="Path 1932"
                            d="M759.128,524.463v.64h-.123a1.163,1.163,0,0,0-1.251,1.251v1.834h-.619V524.52h.619v.633a1.415,1.415,0,0,1,1.251-.691Z"
                            transform="translate(-655.163 -522.967)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1933"
                            data-name="Path 1933"
                            d="M762.868,521.514a.414.414,0,1,1,.417.41A.407.407,0,0,1,762.868,521.514Zm.108,1.143h.619v3.668h-.619Z"
                            transform="translate(-658.343 -521.104)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1934"
                            data-name="Path 1934"
                            d="M766.308,526.319a1.967,1.967,0,0,1,3.632-1l-.539.324a1.323,1.323,0,1,0,0,1.352l.539.323a1.967,1.967,0,0,1-3.632-1Z"
                            transform="translate(-660.251 -522.932)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1935"
                            data-name="Path 1935"
                            d="M779.357,526.593H776.2a1.319,1.319,0,0,0,1.36,1.079,1.519,1.519,0,0,0,1.237-.6l.424.367a2.068,2.068,0,0,1-1.683.8,1.926,1.926,0,0,1-2.006-1.935,1.92,1.92,0,0,1,3.84.015C779.371,526.406,779.364,526.506,779.357,526.593Zm-3.165-.561h2.525a1.281,1.281,0,0,0-2.525,0Z"
                            transform="translate(-665.366 -522.932)"
                            fill="#fff"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
              </a>
            </div>
            <div className="col-6 d-block d-lg-none">
              <div id="socials" className="socials-small">
                <ul className="socials-list">
                  <li>
                    <a
                      href="https://www.youtube.com/channel/UCj5XK8P8-ZIj-PBuNU3nSZg"
                      target="_blank"
                      rel="noreferrer"
                      className="youtube"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                      >
                        <g
                          id="Group_1862"
                          data-name="Group 1862"
                          transform="translate(-463 -3832)"
                        >
                          <path
                            id="Path_1982"
                            d="M17.351,5.676a3.291,3.291,0,0,0-.6-1.51,2.2,2.2,0,0,0-1.51-.654C13.123,3.36,9.951,3.36,9.951,3.36s-3.172,0-5.286.151a2.2,2.2,0,0,0-1.51.654,3.291,3.291,0,0,0-.6,1.51A22.327,22.327,0,0,0,2.4,8.092V9.2a23.9,23.9,0,0,0,.151,2.467,3.291,3.291,0,0,0,.6,1.51,2.43,2.43,0,0,0,1.661.654c1.208.05,5.135.1,5.135.1s3.172,0,5.286-.151a2.2,2.2,0,0,0,1.51-.654,3.291,3.291,0,0,0,.6-1.51A22.327,22.327,0,0,0,17.5,9.2V8.092A22.327,22.327,0,0,0,17.351,5.676ZM8.391,10.609V6.38l4.078,2.114Z"
                            transform="translate(469.049 3839.354)"
                            fill="#00a8ff"
                          />
                          <g
                            id="Rectangle_707"
                            transform="translate(463 3832)"
                            fill="none"
                            stroke="#00a8ff"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                          >
                            <rect width="32" height="32" rx="9" stroke="none" />
                            <rect
                              x="1"
                              y="1"
                              width="30"
                              height="30"
                              rx="8"
                              fill="none"
                            />
                          </g>
                        </g>
                      </svg>
                    </a>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      href="https://www.linkedin.com/company/velosure-cycling-insurance?trk=company_name&original_referer=https%3A%2F%2Fvelosure.co.uk%2F"
                      className="linkedIn"
                      rel="noreferrer"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                      >
                        <g
                          id="Group_1861"
                          data-name="Group 1861"
                          transform="translate(-419 -3832)"
                        >
                          <path
                            id="Path_1983"
                            data-name="Path 1983"
                            d="M14.072,1.5a1.572,1.572,0,0,1,1.571,1.572v11a1.572,1.572,0,0,1-1.571,1.572h-11A1.572,1.572,0,0,1,1.5,14.072v-11A1.572,1.572,0,0,1,3.071,1.5h11m-.393,12.179V9.515a2.562,2.562,0,0,0-2.562-2.562h0A2.277,2.277,0,0,0,9.295,7.975V7.1H7.1v6.577H9.295V9.805a1.1,1.1,0,1,1,2.192,0v3.874h2.192m-9.13-7.81a1.32,1.32,0,0,0,1.32-1.32h0a1.324,1.324,0,1,0-2.648,0h0a1.325,1.325,0,0,0,1.328,1.32m1.092,7.81V7.1H3.464v6.577Z"
                            transform="translate(426.428 3839.429)"
                            fill="#00a8ff"
                          />
                          <g
                            id="Rectangle_706"
                            data-name="Rectangle 706"
                            transform="translate(419 3832)"
                            fill="none"
                            stroke="#00a8ff"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                          >
                            <rect width="32" height="32" rx="9" stroke="none" />
                            <rect
                              x="1"
                              y="1"
                              width="30"
                              height="30"
                              rx="8"
                              fill="none"
                            />
                          </g>
                        </g>
                      </svg>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://twitter.com/cyclevelosure"
                      target="_blank"
                      className="twitter"
                      rel="noreferrer"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                      >
                        <g
                          id="Group_1860"
                          data-name="Group 1860"
                          transform="translate(-375 -3832)"
                        >
                          <path
                            id="Path_1984"
                            data-name="Path 1984"
                            d="M18.175,3.664a7.128,7.128,0,0,1-2.047.574,3.576,3.576,0,0,0,1.564-1.98,7.189,7.189,0,0,1-2.263.874A3.515,3.515,0,0,0,12.8,2,3.565,3.565,0,0,0,9.248,5.569a3.709,3.709,0,0,0,.092.815A10.145,10.145,0,0,1,1.985,2.657,3.555,3.555,0,0,0,3.091,7.408a3.53,3.53,0,0,1-1.622-.416v.025a3.572,3.572,0,0,0,2.862,3.5,3.516,3.516,0,0,1-1.606.058,3.561,3.561,0,0,0,3.328,2.479,7.087,7.087,0,0,1-4.434,1.531,7.257,7.257,0,0,1-.849-.05,10.1,10.1,0,0,0,5.474,1.606A10.1,10.1,0,0,0,16.4,5.985c0-.158,0-.308-.008-.466A7.131,7.131,0,0,0,18.175,3.664Z"
                            transform="translate(381.527 3838.929)"
                            fill="#00a8ff"
                          />
                          <g
                            id="Rectangle_705"
                            data-name="Rectangle 705"
                            transform="translate(375 3832)"
                            fill="none"
                            stroke="#00a8ff"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                          >
                            <rect width="32" height="32" rx="9" stroke="none" />
                            <rect
                              x="1"
                              y="1"
                              width="30"
                              height="30"
                              rx="8"
                              fill="none"
                            />
                          </g>
                        </g>
                      </svg>
                    </a>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      href="https://www.facebook.com/Velosure/"
                      className="facebook"
                      rel="noreferrer"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                      >
                        <g
                          id="Group_1859"
                          data-name="Group 1859"
                          transform="translate(-331 -3832)"
                        >
                          <path
                            id="Path_1981"
                            data-name="Path 1981"
                            d="M8.555,7.115V5.7c0-.613.141-.943,1.131-.943h1.226V2.4H9.026a3.039,3.039,0,0,0-3.3,3.3V7.115H3.84V9.472H5.726v7.072H8.555V9.472h2.074l.283-2.357Z"
                            transform="translate(339.625 3838.528)"
                            fill="#00a8ff"
                          />
                          <g
                            id="Rectangle_704"
                            data-name="Rectangle 704"
                            transform="translate(331 3832)"
                            fill="none"
                            stroke="#00a8ff"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                          >
                            <rect width="32" height="32" rx="9" stroke="none" />
                            <rect
                              x="1"
                              y="1"
                              width="30"
                              height="30"
                              rx="8"
                              fill="none"
                            />
                          </g>
                        </g>
                      </svg>
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-lg-3 mb-3">
              <a
                className="d-inline-flex align-items-center mb-2 link-dark text-decoration-none d-lg-block d-none"
                href="/"
                aria-label="Velosure Icon"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="163.729"
                  height="38.482"
                  viewBox="0 0 163.729 38.482"
                >
                  <g
                    id="Group_1590"
                    data-name="Group 1590"
                    transform="translate(-687.36 -80.891)"
                  >
                    <g
                      id="Group_1563"
                      data-name="Group 1563"
                      transform="translate(687.36 80.891)"
                    >
                      <path
                        id="Path_1898"
                        data-name="Path 1898"
                        d="M454.489,479.122a3.076,3.076,0,0,1,0-5.961.566.566,0,0,0,.434-.609.535.535,0,0,0-.013-.131,23.406,23.406,0,0,0-.7-2.7.641.641,0,0,0-.737-.386,3.045,3.045,0,0,1-3.508-1.438,3.015,3.015,0,0,1,.491-3.715.553.553,0,0,0,.187-.449.616.616,0,0,0-.152-.432,20.755,20.755,0,0,0-1.965-1.965.594.594,0,0,0-.807.035,3.1,3.1,0,0,1-5.329-2.211,3.008,3.008,0,0,1,.1-.733.564.564,0,0,0,0-.377.578.578,0,0,0-.382-.4,18.815,18.815,0,0,0-2.666-.737.6.6,0,0,0-.7.421,3.118,3.118,0,0,1-6.035.035.6.6,0,0,0-.7-.456,17.632,17.632,0,0,0-2.666.737.564.564,0,0,0-.4.648.79.79,0,0,0,.017.128,3.146,3.146,0,0,1,.1.743,3.1,3.1,0,0,1-5.33,2.2.593.593,0,0,0-.807-.035,17.275,17.275,0,0,0-1.965,1.965.617.617,0,0,0-.153.432.554.554,0,0,0,.187.449,3.013,3.013,0,0,1,.491,3.715,3.063,3.063,0,0,1-3.508,1.438.641.641,0,0,0-.737.386,17.982,17.982,0,0,0-.7,2.7.636.636,0,0,0-.015.151.565.565,0,0,0,.436.589,3.076,3.076,0,0,1,0,5.961.566.566,0,0,0-.434.609.583.583,0,0,0,.013.131,23.448,23.448,0,0,0,.7,2.7.64.64,0,0,0,.737.386,3.046,3.046,0,0,1,3.508,1.438,3.014,3.014,0,0,1-.491,3.715.552.552,0,0,0-.187.449.619.619,0,0,0,.153.432,20.765,20.765,0,0,0,1.965,1.964.593.593,0,0,0,.807-.035,3.1,3.1,0,0,1,5.33,2.211,2.988,2.988,0,0,1-.1.733.567.567,0,0,0,0,.377.58.58,0,0,0,.382.4,18.9,18.9,0,0,0,2.666.737.6.6,0,0,0,.7-.421,3.118,3.118,0,0,1,6.035-.035.6.6,0,0,0,.7.456,17.664,17.664,0,0,0,2.666-.737.564.564,0,0,0,.4-.648.7.7,0,0,0-.017-.128,3.122,3.122,0,0,1-.1-.743,3.1,3.1,0,0,1,5.329-2.2.594.594,0,0,0,.807.035,17.335,17.335,0,0,0,1.965-1.964.618.618,0,0,0,.152-.432.551.551,0,0,0-.187-.449,3.015,3.015,0,0,1-.491-3.715,3.063,3.063,0,0,1,3.508-1.438.641.641,0,0,0,.737-.386,17.94,17.94,0,0,0,.7-2.7.611.611,0,0,0,.015-.151A.565.565,0,0,0,454.489,479.122Zm-7.982-11.067q.219.291.423.593a.4.4,0,0,1-.237.609l-10.225,2.462a2.282,2.282,0,0,0-1.591,1.388l-1.083,2.771a.2.2,0,0,1-.37,0l-.384-.986a.992.992,0,0,1,.006-.735l.927-2.262a2.281,2.281,0,0,1,1.559-1.349l10.561-2.633A.4.4,0,0,1,446.507,468.055Zm-11.441,11.278,1.923-4.694a2.281,2.281,0,0,1,1.536-1.343l9.243-2.409a.4.4,0,0,1,.467.232q.157.392.29.8a.393.393,0,0,1-.281.514l-8.7,2.141a2.283,2.283,0,0,0-1.58,1.385l-2.072,5.3a.2.2,0,0,1-.37,0l-.463-1.185A.991.991,0,0,1,435.066,479.333Zm.654-16.676a13.422,13.422,0,0,1,8.743,3.223.4.4,0,0,1-.17.686l-10.658,2.524a2.282,2.282,0,0,0-1.6,1.389l-.171.439a.2.2,0,0,1-.37,0l-2.286-5.874a.71.71,0,0,1,.334-.888A13.414,13.414,0,0,1,435.72,462.657Zm-.207,26.968A13.482,13.482,0,0,1,424.825,468.2a.7.7,0,0,1,1.207.141l7.174,17.391a1.389,1.389,0,0,0,1.284.859h2.489a1.389,1.389,0,0,0,1.285-.863l3-7.329a2.281,2.281,0,0,1,1.548-1.346l5.893-1.5a.4.4,0,0,1,.5.379c0,.071,0,.143,0,.214A13.485,13.485,0,0,1,435.512,489.625Z"
                        transform="translate(-416.514 -456.901)"
                        fill="#00a8ff"
                      />
                      <g
                        id="Group_1560"
                        data-name="Group 1560"
                        transform="translate(41.242 3.703)"
                      >
                        <g
                          id="Group_1558"
                          data-name="Group 1558"
                          transform="translate(0 0)"
                        >
                          <path
                            id="Path_1899"
                            data-name="Path 1899"
                            d="M509.12,465.216h4.462L520,481.7l6.446-16.488h4.432l-8.708,21.261h-4.278Z"
                            transform="translate(-509.12 -465.216)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1900"
                            data-name="Path 1900"
                            d="M552.961,485.367c0-4.9,3.348-8.182,8.4-8.182s8.4,3.285,8.4,8.182v.713l-.311.31H556.742a4.528,4.528,0,0,0,4.619,4.06,4.7,4.7,0,0,0,4.246-2.6h3.782a8.2,8.2,0,0,1-8.027,5.7C556.309,493.549,552.961,490.264,552.961,485.367Zm12.769-2.076a4.68,4.68,0,0,0-8.74,0Z"
                            transform="translate(-533.436 -471.855)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1901"
                            data-name="Path 1901"
                            d="M595.691,465.216h3.719v21.261h-3.719Z"
                            transform="translate(-557.136 -465.216)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1902"
                            data-name="Path 1902"
                            d="M609.053,485.367c0-4.9,3.348-8.182,8.4-8.182s8.4,3.285,8.4,8.182-3.348,8.182-8.4,8.182S609.053,490.264,609.053,485.367Zm13.079,0c0-2.944-1.86-4.9-4.68-4.9s-4.68,1.953-4.68,4.9,1.86,4.9,4.68,4.9S622.132,488.312,622.132,485.367Z"
                            transform="translate(-564.548 -471.855)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1903"
                            data-name="Path 1903"
                            d="M649,487.847h3.5c.124,1.549,1.612,2.6,3.689,2.6s3.47-.806,3.47-2.014c0-.744-.93-1.271-3.811-1.829-4.495-1.022-5.92-2.045-5.92-4.618,0-2.882,2.51-4.8,6.261-4.8a6.738,6.738,0,0,1,6.477,4.029l-3.409.836a3.317,3.317,0,0,0-3.068-1.766c-1.519,0-2.542.62-2.542,1.519,0,.651.713,1.054,2.913,1.55,5.175,1.084,6.818,2.262,6.818,5.083,0,3.068-2.883,5.114-7.189,5.114C652.008,493.549,649.125,491.256,649,487.847Z"
                            transform="translate(-586.705 -471.855)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1904"
                            data-name="Path 1904"
                            d="M700.609,493.655H696.89v-1.147a6.49,6.49,0,0,1-4.215,1.581c-4.247,0-7.067-2.51-7.067-6.291v-9.64h3.719v9.205c0,2.077,1.519,3.44,3.782,3.44s3.781-1.364,3.781-3.44v-9.205h3.719Z"
                            transform="translate(-607.009 -472.394)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1905"
                            data-name="Path 1905"
                            d="M725.693,477.773h3.719V479.6a4.667,4.667,0,0,1,3.75-2.139,4.559,4.559,0,0,1,1.642.31v2.852h-1.271c-2.479,0-4.122,1.395-4.122,3.471v9.174h-3.719Z"
                            transform="translate(-629.242 -472.009)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1906"
                            data-name="Path 1906"
                            d="M746.435,485.367c0-4.9,3.348-8.182,8.4-8.182s8.4,3.285,8.4,8.182v.713l-.31.31H750.215a4.528,4.528,0,0,0,4.619,4.06,4.7,4.7,0,0,0,4.246-2.6h3.782a8.2,8.2,0,0,1-8.028,5.7C749.783,493.549,746.435,490.264,746.435,485.367Zm12.768-2.076a4.679,4.679,0,0,0-8.74,0Z"
                            transform="translate(-640.747 -471.855)"
                            fill="#fff"
                          />
                        </g>
                        <g
                          id="Group_1559"
                          data-name="Group 1559"
                          transform="translate(8.482 24.89)"
                        >
                          <path
                            id="Path_1907"
                            data-name="Path 1907"
                            d="M528.165,524.059a2.527,2.527,0,0,1,2.6-2.568,2.584,2.584,0,0,1,2.165,1.115l-.568.352a1.935,1.935,0,1,0,0,2.2l.568.353a2.585,2.585,0,0,1-2.165,1.115A2.527,2.527,0,0,1,528.165,524.059Z"
                            transform="translate(-528.165 -521.319)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1908"
                            data-name="Path 1908"
                            d="M543.541,524.592l-1.978,4.445a1.036,1.036,0,0,1-.942.676,1.263,1.263,0,0,1-.841-.352l.259-.475a.671.671,0,0,0,.489.23.5.5,0,0,0,.467-.331l.266-.547-1.6-3.647h.712l1.237,2.927,1.237-2.927Z"
                            transform="translate(-534.543 -523.039)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1909"
                            data-name="Path 1909"
                            d="M548.773,526.319a1.967,1.967,0,0,1,3.632-1l-.539.324a1.323,1.323,0,1,0,0,1.352l.539.323a1.967,1.967,0,0,1-3.632-1Z"
                            transform="translate(-539.595 -522.932)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1910"
                            data-name="Path 1910"
                            d="M558.608,521.2h.619v5.179h-.619Z"
                            transform="translate(-545.05 -521.158)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1911"
                            data-name="Path 1911"
                            d="M565.632,526.593h-3.158a1.319,1.319,0,0,0,1.36,1.079,1.519,1.519,0,0,0,1.237-.6l.425.367a2.068,2.068,0,0,1-1.683.8,1.926,1.926,0,0,1-2.007-1.935,1.92,1.92,0,0,1,3.84.015C565.646,526.406,565.639,526.506,565.632,526.593Zm-3.165-.561h2.525a1.281,1.281,0,0,0-2.525,0Z"
                            transform="translate(-546.824 -522.932)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1912"
                            data-name="Path 1912"
                            d="M575.952,521.514a.414.414,0,1,1,.417.41A.407.407,0,0,1,575.952,521.514Zm.108,1.143h.619v3.668h-.619Z"
                            transform="translate(-554.67 -521.104)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1913"
                            data-name="Path 1913"
                            d="M583.356,525.888v2.265h-.619v-2.071A1.012,1.012,0,0,0,581.666,525a1.048,1.048,0,0,0-1.122,1.1v2.057h-.619v-3.668h.619v.561a1.537,1.537,0,0,1,1.324-.647A1.4,1.4,0,0,1,583.356,525.888Z"
                            transform="translate(-556.874 -522.932)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1914"
                            data-name="Path 1914"
                            d="M589.211,527.664l.346-.446a1.552,1.552,0,0,0,1.136.46c.482,0,.849-.187.849-.518,0-.352-.41-.46-.892-.575-.6-.151-1.316-.338-1.316-1.108,0-.712.648-1.079,1.4-1.079a1.972,1.972,0,0,1,1.345.5l-.345.453a1.416,1.416,0,0,0-.993-.4c-.424,0-.777.166-.777.482,0,.359.417.46.906.575.6.144,1.309.324,1.309,1.086,0,.726-.655,1.136-1.481,1.136A2.119,2.119,0,0,1,589.211,527.664Z"
                            transform="translate(-562.024 -522.932)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1915"
                            data-name="Path 1915"
                            d="M597.495,526.808v-2.216h.619v2.129a1.043,1.043,0,0,0,2.086,0v-2.129h.619v2.216a1.666,1.666,0,0,1-3.323,0Z"
                            transform="translate(-566.619 -523.039)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1916"
                            data-name="Path 1916"
                            d="M609.177,524.463v.64h-.122a1.164,1.164,0,0,0-1.251,1.251v1.834h-.619V524.52h.619v.633a1.416,1.416,0,0,1,1.251-.691Z"
                            transform="translate(-571.993 -522.967)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1917"
                            data-name="Path 1917"
                            d="M616.166,524.485v3.668h-.619v-.662a1.675,1.675,0,0,1-1.424.748,1.922,1.922,0,0,1,0-3.841,1.676,1.676,0,0,1,1.424.748v-.662Zm-.619,1.834a1.312,1.312,0,1,0-1.309,1.323A1.286,1.286,0,0,0,615.547,526.319Z"
                            transform="translate(-574.824 -522.932)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1918"
                            data-name="Path 1918"
                            d="M626.782,525.888v2.265h-.619v-2.071A1.012,1.012,0,0,0,625.092,525a1.048,1.048,0,0,0-1.122,1.1v2.057h-.619v-3.668h.619v.561a1.537,1.537,0,0,1,1.324-.647A1.4,1.4,0,0,1,626.782,525.888Z"
                            transform="translate(-580.96 -522.932)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1919"
                            data-name="Path 1919"
                            d="M632.767,526.319a1.967,1.967,0,0,1,3.632-1l-.539.324a1.323,1.323,0,1,0,0,1.352l.539.323a1.967,1.967,0,0,1-3.632-1Z"
                            transform="translate(-586.182 -522.932)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1920"
                            data-name="Path 1920"
                            d="M645.815,526.593h-3.158a1.319,1.319,0,0,0,1.36,1.079,1.519,1.519,0,0,0,1.237-.6l.424.367a2.068,2.068,0,0,1-1.683.8,1.926,1.926,0,0,1-2.007-1.935,1.92,1.92,0,0,1,3.841.015C645.83,526.406,645.823,526.506,645.815,526.593Zm-3.165-.561h2.524a1.28,1.28,0,0,0-2.524,0Z"
                            transform="translate(-591.297 -522.932)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1921"
                            data-name="Path 1921"
                            d="M659.754,524.485v3.668h-.619v-.662a1.675,1.675,0,0,1-1.424.748,1.922,1.922,0,0,1,0-3.841,1.676,1.676,0,0,1,1.424.748v-.662Zm-.619,1.834a1.312,1.312,0,1,0-1.309,1.323A1.286,1.286,0,0,0,659.135,526.319Z"
                            transform="translate(-599 -522.932)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1922"
                            data-name="Path 1922"
                            d="M667.623,523.926v2.028c0,.4.216.568.59.568a1.054,1.054,0,0,0,.51-.137v.583a1.276,1.276,0,0,1-.64.151A.964.964,0,0,1,667,526.055v-2.129h-.661v-.561H667v-.985h.619v.985h1.1v.561Z"
                            transform="translate(-604.805 -521.812)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1923"
                            data-name="Path 1923"
                            d="M678.136,523.926v2.028c0,.4.216.568.59.568a1.054,1.054,0,0,0,.51-.137v.583a1.276,1.276,0,0,1-.64.151.964.964,0,0,1-1.079-1.064v-2.129h-.661v-.561h.661v-.985h.619v.985h1.1v.561Z"
                            transform="translate(-610.636 -521.812)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1924"
                            data-name="Path 1924"
                            d="M687.408,524.114v2.265h-.619v-2.071a1.012,1.012,0,0,0-1.071-1.086,1.048,1.048,0,0,0-1.122,1.1v2.057h-.619V521.2h.619v2.093a1.519,1.519,0,0,1,1.324-.669A1.4,1.4,0,0,1,687.408,524.114Z"
                            transform="translate(-614.586 -521.158)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1925"
                            data-name="Path 1925"
                            d="M697.219,526.593h-3.158a1.319,1.319,0,0,0,1.36,1.079,1.52,1.52,0,0,0,1.237-.6l.424.367a2.069,2.069,0,0,1-1.683.8,1.926,1.926,0,0,1-2.007-1.935,1.92,1.92,0,0,1,3.841.015C697.234,526.406,697.227,526.506,697.219,526.593Zm-3.165-.561h2.525a1.281,1.281,0,0,0-2.525,0Z"
                            transform="translate(-619.809 -522.932)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1926"
                            data-name="Path 1926"
                            d="M709.774,524.463v.64h-.122a1.163,1.163,0,0,0-1.251,1.251v1.834h-.619V524.52h.619v.633a1.415,1.415,0,0,1,1.251-.691Z"
                            transform="translate(-627.789 -522.967)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1927"
                            data-name="Path 1927"
                            d="M713.515,521.514a.413.413,0,1,1,.417.41A.407.407,0,0,1,713.515,521.514Zm.108,1.143h.619v3.668h-.619Z"
                            transform="translate(-630.969 -521.104)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1928"
                            data-name="Path 1928"
                            d="M720.77,528.739l-.64.165c-.014-.331-.3-.546-.719-.546h-1.352a.9.9,0,0,1-1.022-.871.945.945,0,0,1,.453-.827,1.576,1.576,0,0,1-.5-1.165,1.6,1.6,0,0,1,1.676-1.589,1.762,1.762,0,0,1,.9.237.782.782,0,0,1,.834-.633h.281v.575h-.245a.412.412,0,0,0-.453.4,1.541,1.541,0,0,1,.359,1.007,1.608,1.608,0,0,1-1.676,1.6,1.713,1.713,0,0,1-.777-.173.5.5,0,0,0-.23.41c0,.259.209.424.518.424h1.345A1.14,1.14,0,0,1,720.77,528.739Zm-3.143-3.244a1.036,1.036,0,1,0,1.035-1A1,1,0,0,0,717.627,525.5Z"
                            transform="translate(-632.895 -522.439)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1929"
                            data-name="Path 1929"
                            d="M729.995,524.114v2.265h-.619v-2.071a1.012,1.012,0,0,0-1.072-1.086,1.048,1.048,0,0,0-1.122,1.1v2.057h-.619V521.2h.619v2.093a1.518,1.518,0,0,1,1.323-.669A1.4,1.4,0,0,1,729.995,524.114Z"
                            transform="translate(-638.207 -521.158)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1930"
                            data-name="Path 1930"
                            d="M736.743,523.926v2.028c0,.4.216.568.59.568a1.054,1.054,0,0,0,.51-.137v.583a1.276,1.276,0,0,1-.64.151.964.964,0,0,1-1.079-1.064v-2.129h-.662v-.561h.662v-.985h.619v.985h1.1v.561Z"
                            transform="translate(-643.143 -521.812)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1931"
                            data-name="Path 1931"
                            d="M750.457,526.319a1.842,1.842,0,0,1-1.841,1.92,1.676,1.676,0,0,1-1.424-.748v2.029h-.619v-5.035h.619v.662a1.677,1.677,0,0,1,1.424-.748A1.841,1.841,0,0,1,750.457,526.319Zm-.64,0a1.313,1.313,0,1,0-1.316,1.323A1.288,1.288,0,0,0,749.817,526.319Z"
                            transform="translate(-649.305 -522.932)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1932"
                            data-name="Path 1932"
                            d="M759.128,524.463v.64h-.123a1.163,1.163,0,0,0-1.251,1.251v1.834h-.619V524.52h.619v.633a1.415,1.415,0,0,1,1.251-.691Z"
                            transform="translate(-655.163 -522.967)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1933"
                            data-name="Path 1933"
                            d="M762.868,521.514a.414.414,0,1,1,.417.41A.407.407,0,0,1,762.868,521.514Zm.108,1.143h.619v3.668h-.619Z"
                            transform="translate(-658.343 -521.104)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1934"
                            data-name="Path 1934"
                            d="M766.308,526.319a1.967,1.967,0,0,1,3.632-1l-.539.324a1.323,1.323,0,1,0,0,1.352l.539.323a1.967,1.967,0,0,1-3.632-1Z"
                            transform="translate(-660.251 -522.932)"
                            fill="#fff"
                          />
                          <path
                            id="Path_1935"
                            data-name="Path 1935"
                            d="M779.357,526.593H776.2a1.319,1.319,0,0,0,1.36,1.079,1.519,1.519,0,0,0,1.237-.6l.424.367a2.068,2.068,0,0,1-1.683.8,1.926,1.926,0,0,1-2.006-1.935,1.92,1.92,0,0,1,3.84.015C779.371,526.406,779.364,526.506,779.357,526.593Zm-3.165-.561h2.525a1.281,1.281,0,0,0-2.525,0Z"
                            transform="translate(-665.366 -522.932)"
                            fill="#fff"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
              </a>

              <div id="socials" className="d-none d-lg-block socialsNarrow">
                <ul className="socials-list">
                  <li>
                    <a
                      href="https://www.instagram.com/velosure_uk"
                      target="_blank"
                      className="youtube"
                      rel="noreferrer"
                    >
                      <svg width="32" height="32" viewBox="0 0 32 32">
                        <defs>
                          <clipPath id="clipPath87654">
                            <rect
                              id="Rectangle_1161"
                              data-name="Rectangle 1161"
                              width="15.979"
                              height="15.979"
                              fill="#00a8ff"
                            />
                          </clipPath>
                        </defs>
                        <g
                          id="Group_2342"
                          data-name="Group 2342"
                          transform="translate(-463 -3832)"
                        >
                          <g
                            id="Rectangle_707"
                            data-name="Rectangle 707"
                            transform="translate(463 3832)"
                            fill="none"
                            stroke="#00a8ff"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                          >
                            <rect width="32" height="32" rx="9" stroke="none" />
                            <rect
                              x="1"
                              y="1"
                              width="30"
                              height="30"
                              rx="8"
                              fill="none"
                            />
                          </g>
                          <g
                            id="Group_2341"
                            data-name="Group 2341"
                            transform="translate(471 3840.405)"
                          >
                            <g
                              id="Group_2341-2"
                              data-name="Group 2341"
                              clipPath="url(#clipPath87654)"
                            >
                              <path
                                id="Path_2248"
                                data-name="Path 2248"
                                d="M10.867,0H5.112A5.117,5.117,0,0,0,0,5.112v5.755a5.117,5.117,0,0,0,5.112,5.112h5.755a5.117,5.117,0,0,0,5.112-5.112V5.112A5.117,5.117,0,0,0,10.867,0m3.976,10.867a3.98,3.98,0,0,1-3.976,3.976H5.112a3.98,3.98,0,0,1-3.976-3.976V5.112A3.98,3.98,0,0,1,5.112,1.136h5.755a3.98,3.98,0,0,1,3.976,3.976Z"
                                fill="#00a8ff"
                              />
                              <path
                                id="Path_2249"
                                data-name="Path 2249"
                                d="M130.614,126.525a4.089,4.089,0,1,0,4.089,4.089,4.094,4.094,0,0,0-4.089-4.089m0,6.816a2.726,2.726,0,1,1,2.726-2.726,2.729,2.729,0,0,1-2.726,2.726"
                                transform="translate(-122.625 -122.625)"
                                fill="#00a8ff"
                              />
                              <path
                                id="Path_2250"
                                data-name="Path 2250"
                                d="M372.6,100.928a.814.814,0,1,1-.814-.814.814.814,0,0,1,.814.814"
                                transform="translate(-359.541 -97.028)"
                                fill="#00a8ff"
                              />
                            </g>
                          </g>
                        </g>
                      </svg>
                    </a>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      href="https://www.linkedin.com/company/velosure-cycling-insurance?trk=company_name&original_referer=https%3A%2F%2Fvelosure.co.uk%2F"
                      className="linkedIn"
                      rel="noreferrer"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                      >
                        <g
                          id="Group_1861"
                          data-name="Group 1861"
                          transform="translate(-419 -3832)"
                        >
                          <path
                            id="Path_1983"
                            data-name="Path 1983"
                            d="M14.072,1.5a1.572,1.572,0,0,1,1.571,1.572v11a1.572,1.572,0,0,1-1.571,1.572h-11A1.572,1.572,0,0,1,1.5,14.072v-11A1.572,1.572,0,0,1,3.071,1.5h11m-.393,12.179V9.515a2.562,2.562,0,0,0-2.562-2.562h0A2.277,2.277,0,0,0,9.295,7.975V7.1H7.1v6.577H9.295V9.805a1.1,1.1,0,1,1,2.192,0v3.874h2.192m-9.13-7.81a1.32,1.32,0,0,0,1.32-1.32h0a1.324,1.324,0,1,0-2.648,0h0a1.325,1.325,0,0,0,1.328,1.32m1.092,7.81V7.1H3.464v6.577Z"
                            transform="translate(426.428 3839.429)"
                            fill="#00a8ff"
                          />
                          <g
                            id="Rectangle_706"
                            data-name="Rectangle 706"
                            transform="translate(419 3832)"
                            fill="none"
                            stroke="#00a8ff"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                          >
                            <rect width="32" height="32" rx="9" stroke="none" />
                            <rect
                              x="1"
                              y="1"
                              width="30"
                              height="30"
                              rx="8"
                              fill="none"
                            />
                          </g>
                        </g>
                      </svg>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://twitter.com/cyclevelosure"
                      target="_blank"
                      className="twitter"
                      rel="noreferrer"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                      >
                        <g
                          id="Group_1860"
                          data-name="Group 1860"
                          transform="translate(-375 -3832)"
                        >
                          <path
                            id="Path_1984"
                            data-name="Path 1984"
                            d="M18.175,3.664a7.128,7.128,0,0,1-2.047.574,3.576,3.576,0,0,0,1.564-1.98,7.189,7.189,0,0,1-2.263.874A3.515,3.515,0,0,0,12.8,2,3.565,3.565,0,0,0,9.248,5.569a3.709,3.709,0,0,0,.092.815A10.145,10.145,0,0,1,1.985,2.657,3.555,3.555,0,0,0,3.091,7.408a3.53,3.53,0,0,1-1.622-.416v.025a3.572,3.572,0,0,0,2.862,3.5,3.516,3.516,0,0,1-1.606.058,3.561,3.561,0,0,0,3.328,2.479,7.087,7.087,0,0,1-4.434,1.531,7.257,7.257,0,0,1-.849-.05,10.1,10.1,0,0,0,5.474,1.606A10.1,10.1,0,0,0,16.4,5.985c0-.158,0-.308-.008-.466A7.131,7.131,0,0,0,18.175,3.664Z"
                            transform="translate(381.527 3838.929)"
                            fill="#00a8ff"
                          />
                          <g
                            id="Rectangle_705"
                            data-name="Rectangle 705"
                            transform="translate(375 3832)"
                            fill="none"
                            stroke="#00a8ff"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                          >
                            <rect width="32" height="32" rx="9" stroke="none" />
                            <rect
                              x="1"
                              y="1"
                              width="30"
                              height="30"
                              rx="8"
                              fill="none"
                            />
                          </g>
                        </g>
                      </svg>
                    </a>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      href="https://www.facebook.com/Velosure/"
                      className="facebook"
                      rel="noreferrer"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                      >
                        <g
                          id="Group_1859"
                          data-name="Group 1859"
                          transform="translate(-331 -3832)"
                        >
                          <path
                            id="Path_1981"
                            data-name="Path 1981"
                            d="M8.555,7.115V5.7c0-.613.141-.943,1.131-.943h1.226V2.4H9.026a3.039,3.039,0,0,0-3.3,3.3V7.115H3.84V9.472H5.726v7.072H8.555V9.472h2.074l.283-2.357Z"
                            transform="translate(339.625 3838.528)"
                            fill="#00a8ff"
                          />
                          <g
                            id="Rectangle_704"
                            data-name="Rectangle 704"
                            transform="translate(331 3832)"
                            fill="none"
                            stroke="#00a8ff"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                          >
                            <rect width="32" height="32" rx="9" stroke="none" />
                            <rect
                              x="1"
                              y="1"
                              width="30"
                              height="30"
                              rx="8"
                              fill="none"
                            />
                          </g>
                        </g>
                      </svg>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-6 col-lg-2 offset-lg-1 mb-3">
              <h5>Our Cover</h5>
              <ul className="list-unstyled">
                <li className="mb-2">
                  <Link to="/single-bike-insurance">Single bike cover</Link>
                </li>
                <li className="mb-2">
                  <Link to="/multi-bike-insurance">Multi bike cover</Link>
                </li>
                <li className="mb-2">
                  <Link to="/electric-bicycle-insurance">E-bike cover</Link>
                </li>

                { <li className="mb-2">
                  <Link to="/bike-insurance-comparison-chart">
                    Compare our cover
                  </Link>
                </li>}
                <li className="mb-2">
                  <Link to="/OurCoverLevels">Our cover levels</Link>
                </li>
                <li className="mb-2">
                  <Link to="/bicycle-travel-insurance">
                    Additional travel cover
                  </Link>
                </li>
              </ul>
            </div>
            <div className="col-6 col-lg-2 mb-3">
              <h5>Bikes we cover</h5>
              {/* </HashLink> */}
              <ul className="list-unstyled">
                {" "}
                {/*note that the 'to' fields here are not pointing to the actual section, in fact, the one above for scroll performance */}
                <li className="mb-2">
                  <HashLink
                    scroll={(el) =>
                      el.scrollIntoView({ behavior: "smooth", block: "center" })
                    }
                    to="/types-we-cover#electric"
                  >
                    E-bike
                  </HashLink>
                </li>
                <li className="mb-2">
                  <HashLink
                    scroll={(el) =>
                      el.scrollIntoView({ behavior: "smooth", block: "center" })
                    }
                    to="/types-we-cover#road"
                  >
                    Road bike
                  </HashLink>
                </li>
                <li className="mb-2">
                  <HashLink
                    scroll={(el) =>
                      el.scrollIntoView({ behavior: "smooth", block: "center" })
                    }
                    to="/types-we-cover#mountain"
                  >
                    Mountain bike
                  </HashLink>
                </li>
                <li className="mb-2">
                  <HashLink
                    scroll={(el) =>
                      el.scrollIntoView({ behavior: "smooth", block: "center" })
                    }
                    to="/types-we-cover#urban"
                  >
                    Urban bike
                  </HashLink>
                </li>
                <li className="mb-2">
                  <HashLink
                    scroll={(el) =>
                      el.scrollIntoView({ behavior: "smooth", block: "center" })
                    }
                    to="/types-we-cover#sport"
                  >
                    Sports bike
                  </HashLink>
                </li>
                <li className="mb-2">
                  <HashLink
                    scroll={(el) =>
                      el.scrollIntoView({ behavior: "smooth", block: "center" })
                    }
                    to="/types-we-cover#leisure"
                  >
                    Leisure bike
                  </HashLink>
                </li>
              </ul>
            </div>
            <div className="col-6 col-lg-2 mb-3">
              <h5>Information</h5>
              <ul className="list-unstyled">
                <li className="mb-2">
                  <Link to="/policy-information">Policy information</Link>
                </li>
                <li className="mb-2">
                  <Link to="/security-requirements">Security requirements</Link>
                </li>
                <li className="mb-2">
                  <Link to="/bicycle-insurance-faqs">FAQ</Link>
                </li>

                <li className="mb-2">
                  <Link to="/Reviews">Reviews</Link>
                </li>

                <li className="mb-2">
                  <Link to="/Pitstop">Blog</Link>
                </li>
                <li className="mb-2">
                  <Link to="/accessories-we-cover">Accessories we cover</Link>
                </li>
              </ul>
            </div>
            <div className="col-6 col-lg-2 mb-3">
              <h5>Velosure</h5>
              <ul className="list-unstyled">
                <li className="mb-2">
                  <Link to="/contact">Contact us</Link>
                </li>
                <li className="mb-2">
                  <Link to="/about">About us</Link>
                </li>
                <li className="mb-2">
                  <Link to="/SubmitAClaim">Submit a claim</Link>
                </li>
                <li className="mb-2">
                  <Link to="/MakeAComplaint">Make a complaint</Link>
                </li>
                <li className="mb-2">
                  <Link to="/ReferAFriend">Refer a friend</Link>
                </li>
                <li className="mb-2">
                  <Link to="/affiliate-scheme">Affiliate scheme</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section id="section2">
        <div className="container  container_medium">
          <div className="row">
            <div className="col-3 col-xl-2  col-sm-3">
              <a href="/Terms" className="footersection2link">
                <h5>Terms of Use</h5>
              </a>
            </div>
            <div className="col-3 col-xl-2 col-sm-3">
              <a href="/Privacy" className="footersection2link">
                <h5>Privacy Notice</h5>
              </a>
            </div>
            <div className="col-3 col-xl-2 col-sm-3">
              <a href="/Cookies" className="footersection2link">
                <h5>Cookie Policy</h5>
              </a>
            </div>
            <div className="col-3 col-xl-2 col-sm-3">
              <a href="/VulnerabilityPolicy" className="footersection2link">
                <h5>Vulnerability</h5>
              </a>
            </div>
            <div className="col-12 d-none d-sm-none pt-3">
              <img className="Lrqa" src={LRQA} alt="LRQA" />
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-sm-6">
              <p>
                Authorised and Regulated by the Financial Conduct Authority.
                Velosure is a trading style of Lawshield UK Ltd (No. 3360532).
                Registered in England & Wales at 850 Ibis Court, Lakeside Drive,
                Centre Park, Warrington, Cheshire, WA1 1RL.
              </p>

                <p id="footer"  dangerouslySetInnerHTML={{ __html: sessionStorage.getItem('offerFooterText') }} />

              <p>© {new Date().getFullYear()} Lawshield UK Limited.</p>
            </div>
            <div className="col-8 offset-sm-4 col-sm-2 d-block d-sm-block">
              <img className="Lrqa" src={LRQA} alt="LRQA" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Footer;
